import { render } from "./AIRigisterResult.vue?vue&type=template&id=57455262&scoped=true"
import script from "./AIRigisterResult.vue?vue&type=script&lang=js"
export * from "./AIRigisterResult.vue?vue&type=script&lang=js"

import "./AIRigisterResult.vue?vue&type=style&index=0&id=57455262&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57455262"]])

export default __exports__